// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%27100%27 height=%27100%27 viewBox=%270 0 100 100%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z%27 fill=%27rgba%28255,255,255,.03%29%27 fill-rule=%27evenodd%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modern 5D Thinking Assistant Styles inspired by chatScreen.css */
:root {
  --primary-color: #2a9d8f;
  --primary-dark: #1e6e64;
  --primary-light: #8ecec3;
  --secondary-color: #e9c46a;
  --secondary-dark: #dda832;
  --secondary-light: #f4e1b0;
  --text-dark: #264653;
  --text-light: #ffffff;
  --background-light: #f8f9fa;
  --background-dark: #264653;
  --error-color: #e76f51;
  --success-color: #2a9d8f;
  --border-radius-sm: 8px;
  --border-radius-md: 16px;
  --border-radius-lg: 24px;
  --border-radius-xl: 32px;
  --shadow-sm: 0 2px 4px rgba(0, 0, 0, 0.1);
  --shadow-md: 0 4px 8px rgba(0, 0, 0, 0.1);
  --shadow-lg: 0 8px 16px rgba(0, 0, 0, 0.1);
  --transition-fast: 0.2s ease;
  --transition-normal: 0.3s ease;
  --font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: var(--font-family);
  line-height: 1.6;
  color: var(--text-dark);
}

.five-d-assistant-container {
  max-width: 90%;
  margin: 20px auto;
  padding: 20px;
  background: linear-gradient(135deg, #264653, #2a9d8f);
  box-shadow: var(--shadow-lg);
  border-radius: var(--border-radius-lg);
  color: var(--text-light);
  position: relative;
  overflow: hidden;
}

/* Add subtle pattern overlay like chatScreen */
.five-d-assistant-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  opacity: 0.5;
  z-index: 1;
  pointer-events: none;
}

.five-d-assistant-header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2.5rem;
  color: var(--secondary-color);
  width: 100%;
  position: relative;
  z-index: 10;
}

.five-d-logo {
  width: 100px;
  height: auto;
  margin-left: 10px;
  margin-right: 20px;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3));
  position: relative;    /* for its own drop-shadow, etc */
  animation: fadeIn 1s ease-in-out;
  background-color: rgba(255, 255, 255, 0.85);
  padding: 8px;
  border-radius: 40%;
}

.five-d-title {
  font-size: 2.5rem;
  margin: 0;
  color: var(--secondary-color);
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  letter-spacing: 1px;
  font-weight: 700;
  background: linear-gradient(to right, var(--secondary-color), #f4e1b0);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  position: relative;
}

.five-d-title::after {
  content: '';
  position: absolute;
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: linear-gradient(to right, var(--secondary-color), #f4e1b0);
  border-radius: 3px;
}

/* Input section with modern styling like chatScreen */
.input-section {
  margin-bottom: 30px;
  background-color: rgba(255, 255, 255, 0.05);
  padding: 2rem;
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow-md);
  border: 1px solid rgba(255, 255, 255, 0.1);
  position: relative;
  z-index: 10;
  backdrop-filter: blur(10px);
  align-items: center;
  justify-content: center;
  -webkit-backdrop-filter: blur(10px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;

  max-width:70%;
  margin: 0 auto 30px; /* top/auto sides/bottom */
}

.input-section h2 {
  text-align: center;
  font-size: 2rem;
  margin-bottom: 2rem;
  color: var(--secondary-color);
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.input-section h3, 
.input-section h4 {
  font-size: 1.3rem;
  margin-bottom: 1rem;
  color: var(--secondary-light);
  display: flex;
  align-items: center;
}

.input-section h3 svg, 
.input-section h4 svg {
  margin-right: 10px;
  color: var(--secondary-color);
}

.input-group {
  margin-bottom: 2rem;
  position: relative;
  animation: fadeIn 0.5s ease-in-out;
  width: 100%;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.input-container {
  position: relative;
  display: flex;
  align-items: center;
}

.input-section input,
.input-section textarea {
  width: 100%;
  padding: 0.8rem;
  border-radius: var(--border-radius-md);
  border: 1px solid rgba(255, 255, 255, 0.2);
  background-color: rgba(255, 255, 255, 0.1);
  color: var(--text-light);
  transition: all var(--transition-normal);
  font-size: 16px;
  resize: vertical;
  box-shadow: var(--shadow-sm);
}

.input-section input:focus,
.input-section textarea:focus {
  outline: none;
  border-color: var(--secondary-color);
  box-shadow: 0 0 0 2px rgba(233, 196, 106, 0.2);
}

.file-upload-icon {
  background-color: rgba(255, 255, 255, 0.1);
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;
  margin-left: 10px;
  color: var(--secondary-color);
  transition: all var(--transition-normal);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.file-upload-icon:hover {
  background-color: rgba(255, 255, 255, 0.2);
  transform: scale(1.1);
  box-shadow: 0 0 15px rgba(233, 196, 106, 0.4);
}

.file-name {
  margin-top: 0.5rem;
  background-color: rgba(255, 255, 255, 0.1);
  padding: 0.5rem;
  border-radius: var(--border-radius-sm);
  font-size: 0.9rem;
  color: var(--secondary-light);
}

.file-preview {
  margin-top: 1rem;
  background-color: rgba(255, 255, 255, 0.1);
  padding: 1rem;
  border-radius: var(--border-radius-md);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.file-preview h4 {
  margin-bottom: 0.5rem;
  color: var(--secondary-light);
  font-size: 1.1rem;
}

.file-preview p {
  color: var(--text-light);
  font-size: 0.9rem;
  max-height: 150px;
  overflow-y: auto;
  padding-right: 10px;
}

/* Custom Dropdown Styles - modern like chatScreen */
.custom-dropdown {
  position: relative;
  width: 100%;
  max-width: 300px;
}

.custom-dropdown-selected {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.8rem 1rem;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: var(--border-radius-md);
  background-color: rgba(255, 255, 255, 0.1);
  color: var(--text-light);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: all var(--transition-normal);
  box-shadow: var(--shadow-sm);
}

.custom-dropdown-selected:hover {
  border-color: var(--secondary-color);
  box-shadow: 0 0 0 2px rgba(233, 196, 106, 0.1);
}

.custom-dropdown-options {
  position: absolute;
  top: calc(100% + 5px);
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: rgba(38, 70, 83, 0.95);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: var(--border-radius-md);
  overflow: hidden;
  box-shadow: var(--shadow-lg);
  max-height: 200px;
  overflow-y: auto;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.custom-dropdown-option {
  padding: 0.8rem 1rem;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: background-color 0.2s ease;
}

.custom-dropdown-option:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.input-section button {
  padding: 1rem 2rem;
  background-color: var(--secondary-color);
  color: var(--text-dark);
  border: none;
  border-radius: var(--border-radius-md);
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all var(--transition-normal);
  margin-top: 1rem;
  width: 100%;
  max-width: 300px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  box-shadow: var(--shadow-md);
}

.input-section button:hover:not(:disabled) {
  background-color: var(--secondary-dark);
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

.input-section button:active:not(:disabled) {
  transform: translateY(0);
}

.input-section button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.error-message {
  color: var(--error-color);
  margin-top: 10px;
  font-weight: bold;
  background-color: rgba(231, 111, 81, 0.1);
  padding: 0.8rem;
  border-radius: var(--border-radius-md);
  text-align: center;
}

/* Slide Container Styling */
.slide-content {
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  overflow: hidden; /* Ensure content doesn't overflow the container */
  max-width: 60%; /* Match the container width */
  margin-left: auto;
  margin-right: auto;
  position: relative;
  z-index: 10;
}

.slide-content h2 {
  text-align: center;
  margin-bottom: 20px;
  color: var(--primary-color);
  font-size: 2rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  position: relative;
  width: 100%;
}



/* Spinner animation */
@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.spinner {
  font-size: 48px;
  color: var(--secondary-color);
  animation: spin 1s linear infinite;
}

.spinner-small {
  font-size: 0.8em; 
  animation: spin 1s linear infinite;
}

/* Export Button and Dropdown */
.export-dropdown-container {
  position: relative;
  margin-top: 20px;
  z-index: 100;
}

button.export-button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem 2rem;
  background-color: var(--secondary-color);
  color: var(--text-dark);
  border: none;
  border-radius: var(--border-radius-md);
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all var(--transition-normal);
  box-shadow: var(--shadow-md);
  margin: 0 auto;
}

button.export-button:hover {
  background-color: var(--secondary-dark);
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

button.export-button:active {
  transform: translateY(0);
}

.export-dropdown {
  position: absolute;
  bottom: 45px;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.95);
  box-shadow: var(--shadow-lg);
  border-radius: var(--border-radius-md);
  overflow: hidden;
  z-index: 100;
  animation: slideUp 0.3s ease-out;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.export-dropdown .export-button {
  width: 100%;
  padding: 15px;
  background-color: transparent;
  color: var(--text-dark);
  border: none;
  text-align: left;
  cursor: pointer;
  transition: all var(--transition-fast);
  font-weight: 500;
  font-size: 1rem;
  display: flex;
  align-items: center;
}

.export-dropdown .export-button:hover {
  background-color: rgba(42, 157, 143, 0.1);
}

.export-dropdown .export-button:hover svg {
  transform: translateX(3px);
}

.export-dropdown .export-button svg {
  margin-right: 12px;
  transition: transform var(--transition-fast);
}

/* Export spinner overlay */
.export-spinner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  background-color: rgba(38, 70, 83, 0.7);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
}

/* Presentation link styling */
.presentation-link {
  margin: 20px 0;
  padding: 20px;
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: var(--border-radius-md);
  text-align: center;
  box-shadow: var(--shadow-md);
  transition: all var(--transition-normal);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.presentation-link:hover {
  transform: translateY(-5px);
  box-shadow: var(--shadow-lg);
}

.presentation-link p {
  margin: 0 0 10px;
  font-weight: 500;
  color: var(--text-light);
}

.presentation-link a {
  display: inline-block;
  padding: 10px 20px;
  background-color: var(--secondary-color);
  color: var(--text-dark);
  text-decoration: none;
  border-radius: var(--border-radius-md);
  transition: all var(--transition-normal);
  font-weight: 600;
}

.presentation-link a:hover {
  background-color: var(--secondary-dark);
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(233, 196, 106, 0.3);
}

/* Feedback button */
.feedback-button {
  background-color: var(--success-color);
  color: white;
  padding: 12px 16px;
  border: none;
  border-radius: var(--border-radius-md);
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: all var(--transition-normal);
  box-shadow: var(--shadow-md);
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 20;
}

.feedback-button:hover {
  background-color: var(--primary-dark);
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

.feedback-button svg {
  margin-right: 8px;
}

/* Responsive adjustments */
@media (max-width: 1024px) {
  .five-d-assistant-container {
    max-width: 95%;
  }

  .input-section {
    max-width: 85%;
  }

  .slide-content {
    max-width: 75%;
  }
}

@media (max-width: 768px) {
  .five-d-assistant-container {
    max-width: 100%;
    padding: 15px;
    margin: 10px;
  }

  .five-d-assistant-header {
    flex-direction: column;
    text-align: center;
    margin-bottom: 1.5rem;
  }

  .five-d-title {
    font-size: 1.8rem;
    margin-top: 10px;
  }

  .five-d-logo {
    margin: 10px 0 10px 0;
    width: 70px;
    padding: 6px;
  }
  
  .feedback-button {
    position: relative;
    top: auto;
    right: auto;
    margin: 15px auto;
    padding: 10px 14px;
    font-size: 0.9rem;
  }

  .input-section {
    max-width: 95%;
    padding: 1.2rem;
    margin-bottom: 20px;
  }
  
  .input-section h2 {
    font-size: 1.6rem;
    margin-bottom: 1.5rem;
  }

  .input-section h3,
  .input-section h4 {
    font-size: 1.1rem;
    margin-bottom: 0.8rem;
  }

  .input-section input,
  .input-section textarea {
    padding: 0.7rem;
    font-size: 15px;
  }

  .custom-dropdown-selected {
    padding: 0.7rem;
  }

  .slide-content {
    max-width: 95%;
    padding: 10px;
    margin-top: 20px;
  }

  .slide-content h2 {
    font-size: 1.4rem;
  }
}

@media (max-width: 480px) {
  .five-d-assistant-container {
    margin: 5px;
    padding: 10px;
  }

  .five-d-title {
    font-size: 1.5rem;
  }

  .five-d-logo {
    width: 60px;
  }

  .input-section {
    padding: 1rem;
    margin-bottom: 15px;
  }

  .input-section h2 {
    font-size: 1.4rem;
    margin-bottom: 1.2rem;
  }

  .input-section h3,
  .input-section h4 {
    font-size: 1rem;
  }

  .input-section input,
  .input-section textarea {
    padding: 0.6rem;
    font-size: 14px;
  }

  .custom-dropdown {
    width: 100%;
  }

  .custom-dropdown-selected {
    padding: 0.6rem;
    font-size: 14px;
  }

  .file-upload-icon {
    width: 35px;
    height: 35px;
  }

  button.export-button {
    font-size: 0.9rem;
    padding: 0.7rem 1.2rem;
  }

  .error-message {
    padding: 0.6rem;
    font-size: 0.9rem;
  }
}

/* Add iPhone SE / very small device support */
@media (max-width: 375px) {
  .five-d-title {
    font-size: 1.3rem;
  }

  .five-d-logo {
    width: 50px;
  }

  .input-section {
    padding: 0.8rem;
  }

  .input-section h2 {
    font-size: 1.2rem;
  }

  .input-section input,
  .input-section textarea,
  .custom-dropdown-selected {
    padding: 0.5rem;
    font-size: 13px;
  }

  .file-upload-icon {
    width: 32px;
    height: 32px;
  }
}
  `, "",{"version":3,"sources":["webpack://./src/5D-Thinking/FiveDThinking.css"],"names":[],"mappings":"AAAA,mEAAmE;AACnE;EACE,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;EACzB,0BAA0B;EAC1B,oBAAoB;EACpB,qBAAqB;EACrB,2BAA2B;EAC3B,0BAA0B;EAC1B,sBAAsB;EACtB,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,yCAAyC;EACzC,yCAAyC;EACzC,0CAA0C;EAC1C,4BAA4B;EAC5B,8BAA8B;EAC9B,mJAAmJ;AACrJ;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,qDAAqD;EACrD,4BAA4B;EAC5B,sCAAsC;EACtC,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,+CAA+C;AAC/C;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,yDAA+tC;EAC/tC,YAAY;EACZ,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,6BAA6B;EAC7B,WAAW;EACX,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,iDAAiD;EACjD,kBAAkB,KAAK,iCAAiC;EACxD,gCAAgC;EAChC,2CAA2C;EAC3C,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,6BAA6B;EAC7B,yCAAyC;EACzC,mBAAmB;EACnB,gBAAgB;EAChB,sEAAsE;EACtE,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,sEAAsE;EACtE,kBAAkB;AACpB;;AAEA,sDAAsD;AACtD;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,sCAAsC;EACtC,4BAA4B;EAC5B,0CAA0C;EAC1C,kBAAkB;EAClB,WAAW;EACX,2BAA2B;EAC3B,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;;EAElB,aAAa;EACb,mBAAmB,EAAE,0BAA0B;AACjD;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,yCAAyC;AAC3C;;AAEA;;EAEE,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,sCAAsC;EACtC,0CAA0C;EAC1C,0CAA0C;EAC1C,wBAAwB;EACxB,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;;EAEE,aAAa;EACb,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA;EACE,0CAA0C;EAC1C,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,6BAA6B;EAC7B,wCAAwC;EACxC,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;EAC1C,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;EACf,sCAAsC;EACtC,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,0CAA0C;EAC1C,aAAa;EACb,sCAAsC;EACtC,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,oDAAoD;AACpD;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,0CAA0C;EAC1C,sCAAsC;EACtC,0CAA0C;EAC1C,wBAAwB;EACxB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,wCAAwC;EACxC,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,wCAAwC;EACxC,0CAA0C;EAC1C,sCAAsC;EACtC,gBAAgB;EAChB,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,uBAAuB;EACvB,YAAY;EACZ,sCAAsC;EACtC,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,wCAAwC;EACxC,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;EACvC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;EACzC,eAAe;EACf,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,gBAAgB,EAAE,kDAAkD;EACpE,cAAc,EAAE,8BAA8B;EAC9C,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,yCAAyC;EACzC,kBAAkB;EAClB,WAAW;AACb;;;;AAIA,sBAAsB;AACtB;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;EACxC,uBAAuB;EACvB,YAAY;EACZ,sCAAsC;EACtC,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,wCAAwC;EACxC,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,2CAA2C;EAC3C,4BAA4B;EAC5B,sCAAsC;EACtC,gBAAgB;EAChB,YAAY;EACZ,gCAAgC;EAChC,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,WAAW;EACX,aAAa;EACb,6BAA6B;EAC7B,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,uCAAuC;EACvC,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA,8BAA8B;AAC9B;EACE,cAAc;EACd,aAAa;EACb,0CAA0C;EAC1C,0CAA0C;EAC1C,sCAAsC;EACtC,kBAAkB;EAClB,4BAA4B;EAC5B,wCAAwC;EACxC,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,wCAAwC;EACxC,uBAAuB;EACvB,qBAAqB;EACrB,sCAAsC;EACtC,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA,oBAAoB;AACpB;EACE,sCAAsC;EACtC,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,4BAA4B;EAC5B,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,eAAe;IACf,aAAa;IACb,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;IACrB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;;IAEE,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;;IAEE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;;IAEE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA,8CAA8C;AAC9C;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;;IAGE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["/* Modern 5D Thinking Assistant Styles inspired by chatScreen.css */\n:root {\n  --primary-color: #2a9d8f;\n  --primary-dark: #1e6e64;\n  --primary-light: #8ecec3;\n  --secondary-color: #e9c46a;\n  --secondary-dark: #dda832;\n  --secondary-light: #f4e1b0;\n  --text-dark: #264653;\n  --text-light: #ffffff;\n  --background-light: #f8f9fa;\n  --background-dark: #264653;\n  --error-color: #e76f51;\n  --success-color: #2a9d8f;\n  --border-radius-sm: 8px;\n  --border-radius-md: 16px;\n  --border-radius-lg: 24px;\n  --border-radius-xl: 32px;\n  --shadow-sm: 0 2px 4px rgba(0, 0, 0, 0.1);\n  --shadow-md: 0 4px 8px rgba(0, 0, 0, 0.1);\n  --shadow-lg: 0 8px 16px rgba(0, 0, 0, 0.1);\n  --transition-fast: 0.2s ease;\n  --transition-normal: 0.3s ease;\n  --font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n}\n\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  font-family: var(--font-family);\n  line-height: 1.6;\n  color: var(--text-dark);\n}\n\n.five-d-assistant-container {\n  max-width: 90%;\n  margin: 20px auto;\n  padding: 20px;\n  background: linear-gradient(135deg, #264653, #2a9d8f);\n  box-shadow: var(--shadow-lg);\n  border-radius: var(--border-radius-lg);\n  color: var(--text-light);\n  position: relative;\n  overflow: hidden;\n}\n\n/* Add subtle pattern overlay like chatScreen */\n.five-d-assistant-container::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-image: url(\"data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='rgba(255,255,255,.03)' fill-rule='evenodd'/%3E%3C/svg%3E\");\n  opacity: 0.5;\n  z-index: 1;\n  pointer-events: none;\n}\n\n.five-d-assistant-header {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 2.5rem;\n  color: var(--secondary-color);\n  width: 100%;\n  position: relative;\n  z-index: 10;\n}\n\n.five-d-logo {\n  width: 100px;\n  height: auto;\n  margin-left: 10px;\n  margin-right: 20px;\n  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3));\n  position: relative;    /* for its own drop-shadow, etc */\n  animation: fadeIn 1s ease-in-out;\n  background-color: rgba(255, 255, 255, 0.85);\n  padding: 8px;\n  border-radius: 40%;\n}\n\n.five-d-title {\n  font-size: 2.5rem;\n  margin: 0;\n  color: var(--secondary-color);\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  letter-spacing: 1px;\n  font-weight: 700;\n  background: linear-gradient(to right, var(--secondary-color), #f4e1b0);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  position: relative;\n}\n\n.five-d-title::after {\n  content: '';\n  position: absolute;\n  bottom: -6px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 60px;\n  height: 3px;\n  background: linear-gradient(to right, var(--secondary-color), #f4e1b0);\n  border-radius: 3px;\n}\n\n/* Input section with modern styling like chatScreen */\n.input-section {\n  margin-bottom: 30px;\n  background-color: rgba(255, 255, 255, 0.05);\n  padding: 2rem;\n  border-radius: var(--border-radius-lg);\n  box-shadow: var(--shadow-md);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  position: relative;\n  z-index: 10;\n  backdrop-filter: blur(10px);\n  align-items: center;\n  justify-content: center;\n  -webkit-backdrop-filter: blur(10px);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  text-align: center;\n\n  max-width:70%;\n  margin: 0 auto 30px; /* top/auto sides/bottom */\n}\n\n.input-section h2 {\n  text-align: center;\n  font-size: 2rem;\n  margin-bottom: 2rem;\n  color: var(--secondary-color);\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.input-section h3, \n.input-section h4 {\n  font-size: 1.3rem;\n  margin-bottom: 1rem;\n  color: var(--secondary-light);\n  display: flex;\n  align-items: center;\n}\n\n.input-section h3 svg, \n.input-section h4 svg {\n  margin-right: 10px;\n  color: var(--secondary-color);\n}\n\n.input-group {\n  margin-bottom: 2rem;\n  position: relative;\n  animation: fadeIn 0.5s ease-in-out;\n  width: 100%;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.input-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.input-section input,\n.input-section textarea {\n  width: 100%;\n  padding: 0.8rem;\n  border-radius: var(--border-radius-md);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  background-color: rgba(255, 255, 255, 0.1);\n  color: var(--text-light);\n  transition: all var(--transition-normal);\n  font-size: 16px;\n  resize: vertical;\n  box-shadow: var(--shadow-sm);\n}\n\n.input-section input:focus,\n.input-section textarea:focus {\n  outline: none;\n  border-color: var(--secondary-color);\n  box-shadow: 0 0 0 2px rgba(233, 196, 106, 0.2);\n}\n\n.file-upload-icon {\n  background-color: rgba(255, 255, 255, 0.1);\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  cursor: pointer;\n  margin-left: 10px;\n  color: var(--secondary-color);\n  transition: all var(--transition-normal);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.file-upload-icon:hover {\n  background-color: rgba(255, 255, 255, 0.2);\n  transform: scale(1.1);\n  box-shadow: 0 0 15px rgba(233, 196, 106, 0.4);\n}\n\n.file-name {\n  margin-top: 0.5rem;\n  background-color: rgba(255, 255, 255, 0.1);\n  padding: 0.5rem;\n  border-radius: var(--border-radius-sm);\n  font-size: 0.9rem;\n  color: var(--secondary-light);\n}\n\n.file-preview {\n  margin-top: 1rem;\n  background-color: rgba(255, 255, 255, 0.1);\n  padding: 1rem;\n  border-radius: var(--border-radius-md);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.file-preview h4 {\n  margin-bottom: 0.5rem;\n  color: var(--secondary-light);\n  font-size: 1.1rem;\n}\n\n.file-preview p {\n  color: var(--text-light);\n  font-size: 0.9rem;\n  max-height: 150px;\n  overflow-y: auto;\n  padding-right: 10px;\n}\n\n/* Custom Dropdown Styles - modern like chatScreen */\n.custom-dropdown {\n  position: relative;\n  width: 100%;\n  max-width: 300px;\n}\n\n.custom-dropdown-selected {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.8rem 1rem;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: var(--border-radius-md);\n  background-color: rgba(255, 255, 255, 0.1);\n  color: var(--text-light);\n  cursor: pointer;\n  user-select: none;\n  transition: all var(--transition-normal);\n  box-shadow: var(--shadow-sm);\n}\n\n.custom-dropdown-selected:hover {\n  border-color: var(--secondary-color);\n  box-shadow: 0 0 0 2px rgba(233, 196, 106, 0.1);\n}\n\n.custom-dropdown-options {\n  position: absolute;\n  top: calc(100% + 5px);\n  left: 0;\n  right: 0;\n  z-index: 1000;\n  background-color: rgba(38, 70, 83, 0.95);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: var(--border-radius-md);\n  overflow: hidden;\n  box-shadow: var(--shadow-lg);\n  max-height: 200px;\n  overflow-y: auto;\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n}\n\n.custom-dropdown-option {\n  padding: 0.8rem 1rem;\n  cursor: pointer;\n  user-select: none;\n  transition: background-color 0.2s ease;\n}\n\n.custom-dropdown-option:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.input-section button {\n  padding: 1rem 2rem;\n  background-color: var(--secondary-color);\n  color: var(--text-dark);\n  border: none;\n  border-radius: var(--border-radius-md);\n  font-size: 1.1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all var(--transition-normal);\n  margin-top: 1rem;\n  width: 100%;\n  max-width: 300px;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  box-shadow: var(--shadow-md);\n}\n\n.input-section button:hover:not(:disabled) {\n  background-color: var(--secondary-dark);\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-lg);\n}\n\n.input-section button:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.input-section button:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.error-message {\n  color: var(--error-color);\n  margin-top: 10px;\n  font-weight: bold;\n  background-color: rgba(231, 111, 81, 0.1);\n  padding: 0.8rem;\n  border-radius: var(--border-radius-md);\n  text-align: center;\n}\n\n/* Slide Container Styling */\n.slide-content {\n  margin-top: 40px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  overflow: hidden; /* Ensure content doesn't overflow the container */\n  max-width: 60%; /* Match the container width */\n  margin-left: auto;\n  margin-right: auto;\n  position: relative;\n  z-index: 10;\n}\n\n.slide-content h2 {\n  text-align: center;\n  margin-bottom: 20px;\n  color: var(--primary-color);\n  font-size: 2rem;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  position: relative;\n  width: 100%;\n}\n\n\n\n/* Spinner animation */\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n.spinner {\n  font-size: 48px;\n  color: var(--secondary-color);\n  animation: spin 1s linear infinite;\n}\n\n.spinner-small {\n  font-size: 0.8em; \n  animation: spin 1s linear infinite;\n}\n\n/* Export Button and Dropdown */\n.export-dropdown-container {\n  position: relative;\n  margin-top: 20px;\n  z-index: 100;\n}\n\nbutton.export-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem 2rem;\n  background-color: var(--secondary-color);\n  color: var(--text-dark);\n  border: none;\n  border-radius: var(--border-radius-md);\n  font-size: 1.1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all var(--transition-normal);\n  box-shadow: var(--shadow-md);\n  margin: 0 auto;\n}\n\nbutton.export-button:hover {\n  background-color: var(--secondary-dark);\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-lg);\n}\n\nbutton.export-button:active {\n  transform: translateY(0);\n}\n\n.export-dropdown {\n  position: absolute;\n  bottom: 45px;\n  left: 0;\n  right: 0;\n  background-color: rgba(255, 255, 255, 0.95);\n  box-shadow: var(--shadow-lg);\n  border-radius: var(--border-radius-md);\n  overflow: hidden;\n  z-index: 100;\n  animation: slideUp 0.3s ease-out;\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.export-dropdown .export-button {\n  width: 100%;\n  padding: 15px;\n  background-color: transparent;\n  color: var(--text-dark);\n  border: none;\n  text-align: left;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  font-weight: 500;\n  font-size: 1rem;\n  display: flex;\n  align-items: center;\n}\n\n.export-dropdown .export-button:hover {\n  background-color: rgba(42, 157, 143, 0.1);\n}\n\n.export-dropdown .export-button:hover svg {\n  transform: translateX(3px);\n}\n\n.export-dropdown .export-button svg {\n  margin-right: 12px;\n  transition: transform var(--transition-fast);\n}\n\n/* Export spinner overlay */\n.export-spinner-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  background-color: rgba(38, 70, 83, 0.7);\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n}\n\n/* Presentation link styling */\n.presentation-link {\n  margin: 20px 0;\n  padding: 20px;\n  background-color: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: var(--border-radius-md);\n  text-align: center;\n  box-shadow: var(--shadow-md);\n  transition: all var(--transition-normal);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n}\n\n.presentation-link:hover {\n  transform: translateY(-5px);\n  box-shadow: var(--shadow-lg);\n}\n\n.presentation-link p {\n  margin: 0 0 10px;\n  font-weight: 500;\n  color: var(--text-light);\n}\n\n.presentation-link a {\n  display: inline-block;\n  padding: 10px 20px;\n  background-color: var(--secondary-color);\n  color: var(--text-dark);\n  text-decoration: none;\n  border-radius: var(--border-radius-md);\n  transition: all var(--transition-normal);\n  font-weight: 600;\n}\n\n.presentation-link a:hover {\n  background-color: var(--secondary-dark);\n  transform: translateY(-2px);\n  box-shadow: 0 5px 15px rgba(233, 196, 106, 0.3);\n}\n\n/* Feedback button */\n.feedback-button {\n  background-color: var(--success-color);\n  color: white;\n  padding: 12px 16px;\n  border: none;\n  border-radius: var(--border-radius-md);\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  transition: all var(--transition-normal);\n  box-shadow: var(--shadow-md);\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  z-index: 20;\n}\n\n.feedback-button:hover {\n  background-color: var(--primary-dark);\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-lg);\n}\n\n.feedback-button svg {\n  margin-right: 8px;\n}\n\n/* Responsive adjustments */\n@media (max-width: 1024px) {\n  .five-d-assistant-container {\n    max-width: 95%;\n  }\n\n  .input-section {\n    max-width: 85%;\n  }\n\n  .slide-content {\n    max-width: 75%;\n  }\n}\n\n@media (max-width: 768px) {\n  .five-d-assistant-container {\n    max-width: 100%;\n    padding: 15px;\n    margin: 10px;\n  }\n\n  .five-d-assistant-header {\n    flex-direction: column;\n    text-align: center;\n    margin-bottom: 1.5rem;\n  }\n\n  .five-d-title {\n    font-size: 1.8rem;\n    margin-top: 10px;\n  }\n\n  .five-d-logo {\n    margin: 10px 0 10px 0;\n    width: 70px;\n    padding: 6px;\n  }\n  \n  .feedback-button {\n    position: relative;\n    top: auto;\n    right: auto;\n    margin: 15px auto;\n    padding: 10px 14px;\n    font-size: 0.9rem;\n  }\n\n  .input-section {\n    max-width: 95%;\n    padding: 1.2rem;\n    margin-bottom: 20px;\n  }\n  \n  .input-section h2 {\n    font-size: 1.6rem;\n    margin-bottom: 1.5rem;\n  }\n\n  .input-section h3,\n  .input-section h4 {\n    font-size: 1.1rem;\n    margin-bottom: 0.8rem;\n  }\n\n  .input-section input,\n  .input-section textarea {\n    padding: 0.7rem;\n    font-size: 15px;\n  }\n\n  .custom-dropdown-selected {\n    padding: 0.7rem;\n  }\n\n  .slide-content {\n    max-width: 95%;\n    padding: 10px;\n    margin-top: 20px;\n  }\n\n  .slide-content h2 {\n    font-size: 1.4rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .five-d-assistant-container {\n    margin: 5px;\n    padding: 10px;\n  }\n\n  .five-d-title {\n    font-size: 1.5rem;\n  }\n\n  .five-d-logo {\n    width: 60px;\n  }\n\n  .input-section {\n    padding: 1rem;\n    margin-bottom: 15px;\n  }\n\n  .input-section h2 {\n    font-size: 1.4rem;\n    margin-bottom: 1.2rem;\n  }\n\n  .input-section h3,\n  .input-section h4 {\n    font-size: 1rem;\n  }\n\n  .input-section input,\n  .input-section textarea {\n    padding: 0.6rem;\n    font-size: 14px;\n  }\n\n  .custom-dropdown {\n    width: 100%;\n  }\n\n  .custom-dropdown-selected {\n    padding: 0.6rem;\n    font-size: 14px;\n  }\n\n  .file-upload-icon {\n    width: 35px;\n    height: 35px;\n  }\n\n  button.export-button {\n    font-size: 0.9rem;\n    padding: 0.7rem 1.2rem;\n  }\n\n  .error-message {\n    padding: 0.6rem;\n    font-size: 0.9rem;\n  }\n}\n\n/* Add iPhone SE / very small device support */\n@media (max-width: 375px) {\n  .five-d-title {\n    font-size: 1.3rem;\n  }\n\n  .five-d-logo {\n    width: 50px;\n  }\n\n  .input-section {\n    padding: 0.8rem;\n  }\n\n  .input-section h2 {\n    font-size: 1.2rem;\n  }\n\n  .input-section input,\n  .input-section textarea,\n  .custom-dropdown-selected {\n    padding: 0.5rem;\n    font-size: 13px;\n  }\n\n  .file-upload-icon {\n    width: 32px;\n    height: 32px;\n  }\n}\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
